module.exports = __webpack_public_path__ + "static/line_4-6742fe9cc68e49eb1aa6975890b6b1af.svg";